
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import ApprovalRanges from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/ApprovalRanges.vue';
import RequestMaterials from 'src/views/Pages/Dashboard/Supplying/Shopping/RequestMaterial/RequestMaterials.vue';

const ShoppingRoutes = {
    path: 'shopping',
    name: 'shopping.shopping',
    component: MasterTab,
    props: { reference: 'shoppingTabs' },
    children: [
        {
            path: 'approvalrange',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'shopping.approval_ranges',
                    component: ApprovalRanges,
                    meta: {
                        prefix_permission: 'shopping_approvalrange',
                    },
                },
            ],
        },
        {
            path: 'requestmaterial',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'shopping.material_request',
                    component: RequestMaterials,
                    meta: {
                        prefix_permission: 'shopping_requestmaterial',
                    },
                },
            ],
        },
    ]
}

export default ShoppingRoutes;